export const HERO_INTRO_COMPLETE_EVENT = 'hero-intro-complete';
export const HERO_INTRO_RESET_EVENT = 'hero-intro-reset';

let heroIntroComplete = false;

export const resetHeroIntroComplete = () => {
	heroIntroComplete = false;

	if (typeof window !== 'undefined') {
		window.dispatchEvent(new Event(HERO_INTRO_RESET_EVENT));
	}
};

export const markHeroIntroComplete = () => {
	if (heroIntroComplete) return;

	heroIntroComplete = true;

	if (typeof window !== 'undefined') {
		window.dispatchEvent(new Event(HERO_INTRO_COMPLETE_EVENT));
	}
};

export const hasHeroIntroCompleted = () => heroIntroComplete;
